<template>
  <div
    class="lg:px-12 md:px-12 lg:pb-12 md:pb-12 lg:mb-0 md:mb-0 mb-12 md:mt-0 lg:mt-0 mt-20 tabs cust-tabs-body shadow-lg"
  >
    <b-modal id="poetryShareModal" title="Share" centered hide-footer>
      <div class="d-flex justify-content-around mb-8">
        <ShareNetwork
          v-for="network in networks"
          :network="network.network"
          :key="network.network"
          :url="sharing.url"
          :title="sharing.title"
          :description="sharing.description"
        >
          <img class="w-10 h-10 cursor-pointer" :src="network.logo" alt="" />
        </ShareNetwork>
      </div>

      <b-input-group size="md" class="mb-2">
        <b-form-input
          type="text"
          :class="{ inputstyle: applystyle }"
          v-model="copy"
        ></b-form-input>
        <b-input-group-prepend
          ref="poetryShareModalBody"
          type="button"
          is-text
          class="cursor-pointer textstyle"
          @click="doCopy(copy)"
        >
          COPY
        </b-input-group-prepend>
      </b-input-group>
    </b-modal>
    <div v-if="shareWork.result.length">
      <div class="grid lg:grid-cols-2 md:grid-cols-2 grid-cols-1 gap-5 mt-5">
        <div
          class="w-full"
          v-for="(item, index) in shareWork.result"
          :key="`${item} + ${index}`"
        >
          <card class="shadow-lg">
            <div class="flex justify-between items-center">
              <p
                class="text-center text-black font-semibold fsize30px sm-fsize24"
              >
                {{ item.poetryHeading }}
              </p>
              <div class="flex items-center gap-2">
                <div class="bg-primary px-5 py-1 rounded-full">
                  <div
                    class="flex gap-2 cursor-pointer"
                    @click="updateLike(item._id)"
                  >
                    <div>
                      <b-icon
                        v-if="renderlike(item.likedBy)"
                        icon="hand-thumbs-up-fill"
                        font-scale="1.5"
                        class="text-white"
                      />
                      <b-icon
                        v-else
                        icon="hand-thumbs-up"
                        font-scale="1.5"
                        class="text-white"
                      />
                    </div>
                    <p class="text-white">
                      {{ item.likeCount ? item.likeCount : 0 }}
                    </p>
                  </div>
                </div>
                <img
                  v-b-modal.poetryShareModal
                  @click="setLink(url, item.poetryHeading, item.message)"
                  src="../../../../assets/images/share.png"
                  alt="ShareIcon"
                  class="h-5 w-5 cursor-pointer"
                />
              </div>
            </div>
            <div>
              <p class="text-black font-semibold">
                By
                {{ item.firstName + " " + (item.lastName || "") }}
              </p>
            </div>
            <div class="mt-8">
              <div v-html="item.message"></div>
            </div>
          </card>
        </div>
      </div>
      <div class="text-center mt-4" v-if="read > 0">
        <button class="btn" @click="readMore">Read More</button>
        <button class="btn" @click="readLess">Read Less</button>
      </div>
      <div class="text-center mt-4" v-else>
        <button class="btn" @click="readMore">Read More</button>
        <!-- <button class="btn" @click="readLess" >Read Less</button> -->
      </div>
    </div>
    <div v-else>
      <div>
        <div class="flex items-center justify-center gap-2">
          <p class="text-center">No Prose Available</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { BIcon, BIconHandThumbsUpFill, BIconHandThumbsUp } from "bootstrap-vue";
import { mapState } from "vuex";
export default {
  data() {
    return {
      regex: "/(<([^>]+)>)/ig",
      currentPage: 1,
      read: 0,
      perPage: 5,
      less: 0,

      copy: "",
      applystyle: false,

      dianePoetry: `<p>
            Diane lived in Georgia, one of the most populated states in America.
            With many big cities and a geographical range from the mountains to
            the beaches, there is much more to Georgia than its famous peaches.
            Diane’s parents live in Bristol, England, roughly 6608 miles from
            Georgia, and though similarly having much to offer, Bristol and the
            state of Georgia hold many differences. Despite the distance, Diane
            and her family regularly visited one another and communicated often
            through phone calls.
          </p>
          <p>
            During one of Diane’s visits to her parents’ home she noticed that
            both her mother and father were starting to become more frail and
            their mobility was deteriorating. Boris, Diane’s father, during this
            visit climbed upon a chair to change a light bulb and slipped off
            the chair, luckily he was not injured but was very shaken by what
            could have happened. There had been many people over that day who he
            could have asked to complete the job, but he impulsively struggled
            onto the chair to change the bulb. Diane knew that her parents would
            find it difficult to admit that they are struggling and really
            needed some support.
          </p>
          <p>
            Diane made the decision to put her home in Georgia up for rent and
            move countries into her parents’ home. She stated: “It was easier
            for me to move in than for other family members: When questioned
            what she meant by “easier; Diane responded: “Well logistically, as I
            don’t have any children: Emotionally she went on to explain that she
            did not actually feel ready to leave her life in the USA, but things
            just snowballed and her parents needed her.
          </p>
          <p>
            Boris and Barbara live in a large house therefore fortunately there
            was a room available for Diane to use. Diane’s parents live within a
            friendly community and Diane is regularly asked: How’s your mum and
            dad? Diane knows the value of her parents having such a supportive
            local community to feel connected and not fall into loneliness.
          </p>
          <p>
            Diane works full-time as admin support within Social Care, cares for
            her parents full-time, and runs her own business selling handmade
            candles. Though her employer is understanding and she loves her
            parents and business, it can sometimes all feel quite overwhelming.
            Diane shares that her biggest challenge is organising, attending,
            and keeping on top of all her parents hospital appointments. These
            appointments are increasing with time due to her parents’ age and
            her mother recently being diagnosed with cancer. Diane is, however,
            devoted to ensuring her parents have all they need and are safe and
            well.
          </p>
          <p>
            While talking to Diane and hearing all about her life and business
            she suddenly stopped and expressed: “For once it’s not about mum and
            dad; it’s about me!”
          </p>`,

      sharing: {
        url: "",
        title: "",
        description: "",
        // quote: "The hot reload is so fast it's near instant. - Evan You",
        // hashtags: "vuejs,vite,javascript",
        // twitterUser: "youyuxi",
      },

      networks: [
        {
          network: "email",
          name: "Email",
          logo: require("@/assets/icons/Mail.svg"),
          color: "#333333",
        },
        {
          network: "facebook",
          name: "Facebook",
          logo: require("@/assets/icons/facebook.svg"),
          color: "#1877f2",
        },
        {
          network: "linkedin",
          name: "LinkedIn",
          logo: require("@/assets/icons/Linkedin.svg"),
          color: "#007bb5",
        },
        {
          network: "twitter",
          name: "Twitter",
          logo: require("@/assets/icons/Twitter.svg"),
          color: "#1da1f2",
        },
        {
          network: "whatsapp",
          name: "Whatsapp",
          logo: require("@/assets/icons/Whatsapp.svg"),
          color: "#25d366",
        },
      ],
    };
  },
  components: {
    BIcon,
    BIconHandThumbsUpFill,
    BIconHandThumbsUp,
  },
  watch: {
    currentPage() {
      this.$emit("page", this.currentPage);
    },
  },
  methods: {
    async getPhotos() {
      let payload = {
        art: "Photo",
        limit: 100,
        offset: 0,
        status: "Approved",
      };
      try {
        let data = await this.$store.dispatch("hoc/getSharework", payload);
        // console.log(data, "Data");
      } catch (error) {
        console.log(error);
      }
    },
    setLink(link, heading, poetry) {
      this.copy = link;
      this.sharing.url = link;
      this.sharing.title = heading;
      this.sharing.description = this.convertToPlain(poetry);
    },
    convertToPlain(html) {
      var tempDivElement = document.createElement("div");
      tempDivElement.innerHTML = html;
      return tempDivElement.textContent || tempDivElement.innerText || "";
    },

    doCopy(copy) {
      this.$copyText(copy, this.$refs.poetryShareModalBody);
      this.applystyle = true;
      // swal.fire({ title: "", icons: "success" });
      this.$swal.fire({
        text: "Link copied to clipboard",
        confirmButtonColor: "#830c81",
        showCancelButton: false,
        timer: 2000,
      });
    },
    handleRedirect(name) {
      this.$router.push({ name: name });
      this.$swal.fire({
        title: "",
        text: "Please login to access this content",
        icon: "warning",
        confirmButtonColor: "#830c81",
        showCancelButton: false,
      });
    },
    isLogedIn() {
      if (sessionStorage.getItem("token")) {
        return true;
      } else {
        this.handleRedirect("signin");
        return false;
      }
    },
    renderlike(likedBy) {
      if (likedBy && this.user._id) {
        if (likedBy.includes(this.user._id)) {
          return true;
        } else {
          return false;
        }
      }
      return false;
    },
    async updateLike(shareWorkId) {
      if (!this.isLogedIn()) {
        return;
      }

      let payload = {
        shareWorkId: shareWorkId,
      };
      try {
        let data = await this.$store.dispatch("hoc/setLike", payload);
        if (data.code === 200) {
          await this.getShareWorks();
        }
        // if (data.code === 401) {
        //   this.handleRedirect("signin");
        // }
      } catch (error) {
        console.log(error);
      }
    },
    async readMore() {
      let loader = this.$loading();
      this.read++;
      // console.log("R1", this.read);
      // console.log("L1", this.less);

      await this.$store.commit("hoc/READ_MORE", this.read);
      loader.close();
      // this.$parent.$emit("read", this.readMore);
    },
    async readLess() {
      let loader = this.$loading();

      this.read--;
      this.less--;
      // console.log("L2", this.less);
      // console.log("R2", this.read);
      await this.$store.commit("hoc/READ_LESS", this.less);
      loader.close();
    },
    getShareWorks() {
      this.$emit("getShareWorks", "Poetry");
    },
  },
  computed: {
    ...mapState("hoc", { shareWork: "shareWork", readM: "readMore" }),
    ...mapState("auth", { user: "user" }),
    url() {
      return window.location.href;
    },
  },
  mounted() {
    this.getPhotos();
    // console.log(this.shareWork, "ShareWork");
  },
};
</script>

<style></style>
